module.exports = __webpack_public_path__ + "img/ep-rectangle-1angle-arrondi.d50ca418.jpg";